import {useMutation, useQueryClient} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {httpCancelExport} from '@/features/exports/http/exports.http'
import {patchExportInCache} from '@/features/exports/query/exportsCache'
import {errorHandler} from '@/utilities/helpers'
import {toast} from '@/utilities/toast/toast'
import {useTranslation} from '@/translations/i18n'

/**
 * Cancel a pending/processing export job (FR-018). The returned cancelled job reconciles
 * the cached lists. 409 EXPORT_NOT_CANCELLABLE is surfaced via the shared error handler.
 */
export const useCancelExport = () => {
    const queryClient = useQueryClient()
    const {t} = useTranslation()

    return useMutation({
        mutationKey: [MUTATION_KEYS.CANCEL_EXPORT],
        mutationFn: (id: string) => httpCancelExport(id),
        onSuccess: job => {
            patchExportInCache(queryClient, job)
            toast.success(t('exports:toast_cancelled'))
        },
        onError: errorHandler
    })
}
